import React, { useState, useEffect, useRef } from 'react';
import '../../styles/components.css';
import countryCodes from '@/components/registration/CountryCodes.jsx';

const getFlagEmoji = (countryCode) => {
    if (!countryCode || countryCode.length !== 2) return countryCode;

    return countryCode
        .toUpperCase()
        .split('')
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join('');
};

const CountryCodePicker = ({ selectedCode, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [filteredCodes, setFilteredCodes] = useState(countryCodes);
    const dropdownRef = useRef(null);
    const selectedCountry = countryCodes.find((country) => country.code === selectedCode) || countryCodes[0];

    useEffect(() => {
        if (!selectedCode) {
            onSelect(countryCodes[0].code);
        }

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectedCode, onSelect]);

    useEffect(() => {
        if (search) {
            const filtered = countryCodes.filter((item) =>
                item.country.toLowerCase().includes(search.toLowerCase()) ||
                item.code.includes(search)
            );
            setFilteredCodes(filtered);
        } else {
            setFilteredCodes(countryCodes);
        }
    }, [search]);

    const handleSelectCountry = (code) => {
        onSelect(code);
        setIsOpen(false);
        setSearch('');
    };

    return (
        <div className="country-code-picker" ref={dropdownRef}>
            <button
                type="button"
                className="country-code-button"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="country-flag">{getFlagEmoji(selectedCountry.flag)}</span>
                <span className="country-code">{selectedCountry.code}</span>
                <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
            </button>

            {isOpen && (
                <div className="country-dropdown">
                    <div className="country-search">
                        <input
                            type="text"
                            placeholder="Search country or code"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="country-list">
                        {filteredCodes.map((item) => (
                            <div
                                key={item.code}
                                className={`country-item ${item.code === selectedCode ? 'selected' : ''}`}
                                onClick={() => handleSelectCountry(item.code)}
                            >
                                <span className="country-flag">{getFlagEmoji(item.flag)}</span>
                                <span className="country-name">{item.country}</span>
                                <span className="country-code">{item.code}</span>
                            </div>
                        ))}
                        {filteredCodes.length === 0 && (
                            <div className="no-results">No results found</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CountryCodePicker;
